import * as React from 'react';
import { WrappedMessage } from 'utils';
import messages from './displayMessages';

interface ResultsCountProps {
    totalCount: number;
}

export class ResultsCount extends React.Component<ResultsCountProps> {

    public render() {
        return (
            <WrappedMessage
                message={messages.resultsCountTotal}
                values={{
                    totalCount: this.props.totalCount,
                }}
            />
        );
    }
}
